import { InjectionToken } from '@angular/core';

export interface SsrRequestContext {
  ip: string;
  userAgent: string;
  referer: string;
  url: string;
}

export const SSR_REQUEST_CONTEXT = new InjectionToken<SsrRequestContext>('SSR_REQUEST_CONTEXT');
